import { ICommonSettings } from "@kuika/kuika-cl-model";
import { PureComponent, ReactNode } from "react";
import { ICommonConfigDeleteFunctionParams, ICommonConfigSaveFunctionParams } from "../app-settings-config-container";
import { ConfigSettingSelect } from "../config-setting-select";
import { ConfigJiraMcpSettings } from "./app-settings-config-jira";

export interface IConfigJiraInputState {
  showModal: boolean;
  editingJiraMcpId: string;
}

export interface IConfigJiraInputProps {
  parentConfigValue?: string | null;
  commonSettings: ICommonSettings;
  getSectionDescription: (contentKey: string) => ReactNode;
  handleUpdateCustomFormInput?: (formItemName: string[], value: string | null) => void;
  handleCreateCommonConfig: (params: ICommonConfigSaveFunctionParams) => void;
  handleUpdateCommonConfig: (params: ICommonConfigSaveFunctionParams) => void;
  handleDeleteCommonConfig: (params: ICommonConfigDeleteFunctionParams) => void;
}

export class ConfigJiraInput extends PureComponent<IConfigJiraInputProps, IConfigJiraInputState> {
  formInputName: string[] = ["apiConfig", "jiraMcpSettingsId"];

  constructor(props: IConfigJiraInputProps) {
    super(props);
    this.state = {
      showModal: false,
      editingJiraMcpId: ""
    };
  }

  openModal = (): void => {
    this.setState({ showModal: true, editingJiraMcpId: "" });
  };

  closeModal = (): void => {
    this.setState({ showModal: false });
  };

  setEditingSetting = (id: string): void => {
    this.setState({ editingJiraMcpId: id, showModal: true });
  };

  handleRestore = (): void => {
    this.props.handleUpdateCustomFormInput?.(this.formInputName, this.props.parentConfigValue ?? null);
  };

  render(): ReactNode {
    return (
      <>
        <ConfigJiraMcpSettings
          formInputName={this.formInputName}
          closeModal={this.closeModal}
          showModal={this.state.showModal}
          editingJiraMcpId={this.state.editingJiraMcpId}
          commonSettings={this.props.commonSettings}
          getSectionDescription={this.props.getSectionDescription}
          handleCreateCommonConfig={this.props.handleCreateCommonConfig}
          handleUpdateCommonConfig={this.props.handleUpdateCommonConfig}
          handleDeleteCommonConfig={this.props.handleDeleteCommonConfig}
        />
        <ConfigSettingSelect
          label="Jira"
          formInputName={this.formInputName}
          options={this.props.commonSettings.jiraMcpSettings ?? []}
          allowClear
          tooltipContentKey="appsettings_mcp_jira"
          onAddNew={this.openModal}
          onEdit={this.setEditingSetting}
          parentConfigValue={this.props.parentConfigValue}
          onRestore={this.handleRestore}
          dropdownTestId="appSettingsMcpJiraDropdown"
          addNewTestId="appSettingsMcpJiraAddNewButton"
          editTestId="appSettingsMcpJiraEditButton"
        />
      </>
    );
  }
}
